import React, { useState } from "react";
import Swal from "sweetalert2";
import imglogo from "../../assets/icons/contract.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from 'react-icons/fa';
import Breadcrumb from "../Pages/Breadcrumb";
import { useLanguage } from "../../store/language-context"
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ContractualCourses = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    last_name: "",
    email: "",
    phone: "",
    company: "",
    position: "",
    description: "",

    courses: [
      {
        title: "",
        number: 1,
        location: "",
        in_date: "",  // Start Date
        to_date: "",  // End Date
      },
    ],
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleCloseModal = () => setShowForm(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");
    const formatDate = (date) => {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = `${d.getMonth() + 1}`.padStart(2, '0');
      const day = `${d.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const coursesToSend = formData.courses.map((course) => ({
      title: course.title,
      number_participants: course.number,
      place: course.location,
      start_date: formatDate(course.in_date),
      end_date: formatDate(course.to_date),
    }));

    try {
      const response = await fetch(
        `${URL}/contractual-courses`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            courses: coursesToSend,
          }),
        }
      );

      if (response.ok) {
        await response.json();
        setResponseMessage("Form submitted successfully!");

        Swal.fire({
          title: t('contractual.done'),
          text: t('contractual.done-msg'),
          icon: "success",
          confirmButtonText: t('custom.accept'),
          confirmButtonColor: "#6A2F38",
        });

        setFormData({
          name: "",
          last_name: "",
          email: "",
          phone: "",
          company: "",
          position: "",
          description: "",
          number: 1,
          in_date: "",
          to_date: "",
          courses: [
            {
              title: "",
              number: 1,
              location: "",
              in_date: "",
              to_date: "",
            },
          ], // reset with default course
        });

        setShowForm(false);
      } else {
        const errorData = await response.json();
        setResponseMessage(`Error: ${errorData.message || "Submission failed."}`);

        Swal.fire({
          title: t('custom.err-title'),
          text: errorData.message || t('custom.err'),
          icon: "error",
          confirmButtonText: t('custom.accept'),
          confirmButtonColor: "#6A2F38",
        });
      }
    } catch (error) {
      setResponseMessage(`Error: ${error.message}`);

      Swal.fire({
        title: t('custom.err-title'),
        text: t('custom.err'),
        icon: "error",
        confirmButtonText: t('custom.accept'),
        confirmButtonColor: "#6A2F38",
      });
    } finally {
      setLoading(false);
    }
  };
  const [phoneError, setPhoneError] = useState("");
  const isValidName = (name) => {
    const regex = /^[A-Za-zأ-ي ]+$/; // Allows alphabetic characters and spaces
    return regex.test(name);
  };


  const validatePhone = (phone) => {
    // Check if the phone number has at least 10 digits
    const regex = /^[0-9]{10,}$/; // Ensures the phone number has at least 10 digits
    return regex.test(phone);
  };

  const handleChangephone = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      if (!validatePhone(value)) {
        setPhoneError(t('contractual.phone-err'));
      } else {
        setPhoneError(""); // Clear the error if the phone number is valid
      }
    }
    if (name === "name" && !isValidName(value)) {
      setFirstNameError(t('contractual.name-err'));
    } else if (name === "last_name" && !isValidName(value)) {
      setLastNameError(t('contractual.name-err'));
    } else {
      // Clear the error if the input is valid
      if (name === "name") setFirstNameError("");
      if (name === "last_name") setLastNameError("");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const styles = {
    button: {},
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: showForm ? "block" : "none",
      zIndex: 1000,
    },
    modalContent: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      color: "black", // Changed to black for better visibility
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 1001,
      maxHeight: "100vh", // Limit the height of the modal
      overflowY: "auto", // Allow vertical scrolling if content overflows
    },
    closeButton: {
      color: "#fff",
      border: "1px solid #fff",
      borderRadius: "50%",
      fontSize: "14px",
      fontWeight: "800",
      cursor: "pointer",
      backgroundColor: "transparent",
    },
    formRow: {
      display: "flex",
      flexWrap: "wrap",

      marginBottom: "10px",
      padding: "0px",
      margin: "0px",
    },
    inputWrapper: {},
    label: {},
    input: {
      width: "100%",
      padding: "10px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      boxSizing: "border-box",
      backgroundColor: "#F5F5F5",
      color: "#aaa",
      minHeight: "40px",
    },
    textarea: {
      width: "100%",
      padding: "5px",
      borderRadius: "4px",
      border: "1px solid #ccc",

      boxSizing: "border-box",
      backgroundColor: "#F5F5F5",
      color: "#333",
      Outline: "none",
    },
  };

  return (
    <>
      <Breadcrumb pages={[t('routes.contractural')]} />

      <div className="centeral-form-new">
        <div className="container">
          <div onClick={handleCloseModal}>
            <div>
              <form onSubmit={handleSubmit}>
                <div
                  className=""
                  style={styles.formRow}
                >
                  {/* Toggle between Select dropdown and manual input */}
                  <div className="client-section row align-items-start justify-content-between gap-3">

                    <p className="text-secondary-tw text-xl ltr:text-left rtl:text-start">
                      {t('contractual.client-data')} :
                    </p>
                    <div className="contral-field" style={styles.inputWrapper}>
                      <label>
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contact.first-name')}</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChangephone}
                        style={styles.input}
                        required
                      />
                      {firstNameError && (
                        <p
                          style={{
                            color: "#D4AD89",
                            fontSize: "12px",
                            marginTop: "5px",
                          }}
                        >
                          {firstNameError}
                        </p>
                      )}
                    </div>

                    <div className="contral-field" style={styles.inputWrapper}>
                      <label>
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contact.last-name')}</span>
                      </label>
                      <input
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleChangephone}
                        style={styles.input}
                        required
                      />
                      {lastNameError && (
                        <p
                          style={{
                            color: "#D4AD89",
                            fontSize: "12px",
                            marginTop: "5px",
                          }}
                        >
                          {lastNameError}
                        </p>
                      )}
                    </div>

                    <div className="contral-field" style={styles.inputWrapper}>
                      <label style={styles.label}>
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contact.email')}</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        style={styles.input}
                        required
                      />
                    </div>

                    {/* Phone and Company Fields */}
                    <div className="contral-field" style={styles.inputWrapper}>
                      <label style={styles.label}>
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contact.phone')}</span>
                      </label>
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChangephone}
                        style={styles.input}
                        required
                      />
                      {phoneError && (
                        <p
                          style={{
                            color: "#D4AD89",
                            fontSize: "12px",
                            marginTop: "5px",
                          }}
                        >
                          {phoneError}
                        </p>
                      )}
                    </div>

                    <div className="contral-field" style={styles.inputWrapper}>
                      <label style={styles.label}>
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contact.company')}</span>
                      </label>
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        style={styles.input}
                      />
                    </div>

                    {/* Position and Date Fields */}

                    <div className="contral-field" style={styles.inputWrapper}>
                      <label style={styles.label}>
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contact.job')}</span>
                      </label>
                      <input
                        type="text"
                        name="position"
                        value={formData.position}
                        onChange={handleChange}
                        style={styles.input}
                      />
                    </div>
                  </div>

                  <div className="w-full">
                    <p className="text-secondary-tw text-xl ltr:text-left rtl:text-start">
                      {t('contractual.courses-data')} :
                    </p>
                  </div>

                  {/* Other form fields */}
                  <div
                    className="col-md-12 p-0 "
                    style={styles.inputWrapper}
                  >

                    {formData.courses.map((course, index) => (
                      <div className="client-section section-2 row align-items-start justify-content-between gap-3 col-12">
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "row", // Items aligned horizontally in a row

                            marginBottom: "10px",
                            flexWrap: "wrap",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "start",
                          }}
                          className="gap-3"
                        >
                          {/* Course Title */}
                          <div className="course-field">
                            <label>
                              <img src={imglogo} alt="" />
                              <span>{t('custom.course-name')}</span>
                            </label>
                            <input
                              type="text"
                              value={course.title}
                              onChange={(e) => {
                                const newCourses = [...formData.courses];
                                newCourses[index].title = e.target.value;
                                setFormData((prev) => ({
                                  ...prev,
                                  courses: newCourses,
                                }));
                              }}
                              style={{ ...styles.input, width: "100%" }}
                              required
                            />
                          </div>

                          {/* Number of Participants */}
                          <div className="course-field">
                            <label>
                              <img src={imglogo} alt="" />
                              <span>{t('contractual.number-trainers')}</span>
                            </label>
                            <input
                              type="number"
                              value={course.number}
                              onChange={(e) => {
                                const newCourses = [...formData.courses];
                                newCourses[index].number = e.target.value;
                                setFormData((prev) => ({
                                  ...prev,
                                  courses: newCourses,
                                }));
                              }}
                              style={{ ...styles.input, width: "100%" }}
                              required
                            />
                          </div>

                          {/* Location */}
                          <div className="course-field">
                            <label>
                              <img src={imglogo} alt="" />
                              <span>{t('contractual.location')}</span>
                            </label>
                            <input
                              type="text"
                              value={course.location}
                              onChange={(e) => {
                                const newCourses = [...formData.courses];
                                newCourses[index].location = e.target.value;
                                setFormData((prev) => ({
                                  ...prev,
                                  courses: newCourses,
                                }));
                              }}
                              style={{ ...styles.input, width: "100%" }}
                              required
                            />
                          </div>

                          {/* Start Date Picker */}
                          <div className="course-field">
                            <label style={{ display: "block", textAlign: "right" }}>
                              <span>{t('contact.start-date')}</span>
                            </label>
                            <div className="datepicker-wrapper">
                              <DatePicker
                                selected={course.in_date ? new Date(course.in_date) : null}
                                onChange={(date) => {
                                  const newCourses = [...formData.courses];
                                  newCourses[index].in_date = date;
                                  if (newCourses[index].to_date && new Date(newCourses[index].to_date) < date) {
                                    newCourses[index].to_date = date; // Ensure end date is after the start date
                                  }
                                  setFormData((prev) => ({ ...prev, courses: newCourses }));
                                }}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="dd/mm/yyyy"
                                className="select-ui bg-gray-200 datepicker-input"
                                maxDate={course.to_date ? new Date(course.to_date) : null}
                              />
                              <FaCalendarAlt className="calendar-icon" style={{ color: '#6A2F38' }} />
                            </div>
                          </div>

                          {/* End Date Picker */}
                          <div className="course-field">
                            <label style={{ display: "block", textAlign: "right" }}>
                              <span>{t('contact.end-date')}</span>
                            </label>
                            <div className="datepicker-wrapper">
                              <DatePicker
                                selected={course.to_date ? new Date(course.to_date) : null}
                                onChange={(date) => {
                                  const newCourses = [...formData.courses];
                                  newCourses[index].to_date = date;
                                  // Ensure end date is after the start date
                                  if (new Date(newCourses[index].to_date) < new Date(newCourses[index].in_date)) {
                                    newCourses[index].to_date = newCourses[index].in_date; // Reset to the same as start date if invalid
                                  }
                                  setFormData((prev) => ({ ...prev, courses: newCourses }));
                                }}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="dd/mm/yyyy"
                                className="select-ui bg-gray-200 datepicker-input"
                                minDate={course.in_date ? new Date(course.in_date) : null}
                              />
                              <FaCalendarAlt className="calendar-icon" style={{ color: '#6A2F38' }} />
                            </div>
                          </div>

                          <div className="course-field"></div>
                          {/* Delete Button */}
                          {formData.courses.length > 1 && (
                            <button
                              className="delete-course-button"
                              type="button"
                              onClick={() => {
                                const newCourses = formData.courses.filter(
                                  (_, i) => i !== index
                                );
                                setFormData((prev) => ({
                                  ...prev,
                                  courses: newCourses,
                                }));
                              }}
                              style={{
                                width: "25px",
                                height: "25px",
                                borderRight: "50%",


                                border: "1px solid #6A2F38",
                                color: "#fff",


                                fontSize: "14px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",


                                justifyContent: "center",
                              }}
                              title="delete"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Add Button for new Course */}
                  <button
                    type="button"
                    className="add-course-button"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        courses: [
                          ...prev.courses,
                          {
                            title: "",
                            number: 1,
                            location: "",
                            in_date: "",
                            to_date: "",
                          },
                        ],
                      }))
                    }
                    style={{
                      minWidthwidth: "200px",

                      backgroundColor: "transparent",
                      color: "#414042",


                      borderRadius: "4px",
                      fontSize: "16px",
                      cursor: "pointer",
                      display: "flex",
                      margin: " 30px auto",
                      padding: " 0 10px",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "background-color 0.3s, color 0.3s",
                    }}

                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "transparent";
                      e.currentTarget.style.color = "#6A2F38";
                    }}
                    title="أضف دورة"
                  >
                    <i className="fa fa-plus me-2"></i>
                    {t('contractual.add-course')}
                  </button>

                  <div className="row gap-4  col-12 sm:grid-cols-1 client-section">
                    <div className="col-md-4" style={styles.inputWrapper}>
                      <label >
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contractual.files')}</span>
                      </label>

                      {/* File Upload Section */}
                      <div
                        className="input-container contral-field"
                        style={styles.input}
                      >
                        {/* Hidden File Input */}
                        <input
                          id="fileInput"
                          type="file"
                          className="d-none" // This hides the file input
                          style={styles.input}
                          onChange={(e) => {
                            // Handle the file selection and display file name
                            const selectedFile = e.target.files[0];
                            if (selectedFile) {
                              setFormData({
                                ...formData,
                                file: selectedFile, // Store the file in form data
                              });
                            }
                          }}
                        />
                        {formData.file && (
                          <p
                            style={{
                              color: "#333",
                              fontSize: "14px",
                              textAlign: "start",
                            }}
                          >
                            {formData.file.name}
                          </p>
                        )}
                        {/* Attachment Icon */}
                        <i
                          className="attachment-icon fa fa-paperclip"
                          style={{ color: "#D4AD89", cursor: "pointer" }}
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          } // Trigger file input click
                        />
                      </div>

                      {/* Display Selected File Name */}
                    </div>

                    <div className="col-md-12">
                      <label style={styles.label}>
                        <img src={imglogo} alt="logo-icon" />
                        <span>{t('contractual.add-data')}</span>
                      </label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        style={styles.textarea}
                        rows="5"
                      />
                    </div>
                  </div>
                  <label className="terms mt-1 mb-1 d-block p-1">
                    <input type="checkbox" required />
                    <span>
                      {t('contact.i-agree')}
                      <Link to="/privacy" className="mx-2">
                        {t('contractual.company-privacy')}
                      </Link>
                    </span>
                  </label>

                  <label className="terms col-12 p-1">
                    <input type="checkbox" required />
                    <span>{t('contractual.add-news')}</span>
                  </label>

                </div>

                <div className="two-form-btn">
                  <button
                    type="submit"
                    disabled={loading}
                    style={styles.button}
                    className="submit-button"
                  >
                    {loading ? `${t('custom.sending')}` : t('custom.send')}
                  </button>
                  <button
                    className="reset-btn"
                    type="button"
                    onClick={() =>
                      setFormData({
                        name: "",
                        last_name: "", 
                        email: "",
                        phone: "",
                        company: "",
                        position: "",
                        description: "",
                        number: 1,
                        in_date: "",
                        to_date: "",
                        courses: [],
                        title: [],
                      })
                    }
                  >
                    {t('custom.delete')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContractualCourses;